import Flickity from 'flickity';

export default class JoinUs {
  constructor() {
    const $els = document.querySelectorAll('.js-join-us');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.activeClass = 'is-active';
    this.$tabs = this.$el.querySelectorAll('.js-join-us-tab');
    this.$carousel = this.$el.querySelector('.js-join-us-carousel');

    this.flickity = new Flickity(this.$carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
      wrapAround: true,
      draggable: false,
    });

    window.addEventListener('hashchange', this.goToHash.bind(this));

    this.flickity.on('select', this.onSelect.bind(this));

    this.$tabs.forEach(($tab, index) => {
      $tab.addEventListener('click', this.onTabClick.bind(this, $tab, index));
    });

    if (window.location.hash) {
      this.goToHash()
    }
    else {
      this.$tabs[0].classList.add(this.activeClass)
    }
  }

  onTabClick($tab, index) {
    history.pushState({}, "", "#" + $tab.dataset.hash);

    this.goToSlide($tab, index)
  }

  goToHash() {
    try {
      var el = this.$el.querySelector(window.location.hash)
      var idx = [...el.parentNode.children].indexOf(el)

      this.goToSlide(el, idx)
    }
    catch (e) {
    }
  }

  /**
   * @function goToSlide
   * @param {HTMLButtonElement} $tab tab that has been clicked
   * @param {Number} index slide index
   * @returns void
   * Goes to specific slide in carousel based on index
   */
  goToSlide($tab, index = 0) {
    if (!this.flickity || !$tab) return;

    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    $tab.classList.add(this.activeClass);

    this.flickity.select(index);
  }

  /**
   * @function onSelect
   * @param {Number} index
   * Fired when the Flickity slide changes
   */
  onSelect(index) {
    this.$tabs.forEach($tab => $tab.classList.remove(this.activeClass));
    this.$tabs[index]?.classList.add(this.activeClass);
  }
}
